// NOTE : do not edit this file
//
// it is auto-generated to update the prefix to a value that matches the environment
// if you do want to change this file, remember to update the build pipeline accordingly

export const prefixHolder = {
  Gateway: 'https://id.chatclb.dev',
  Backend: 'https://api.chatclb.dev',
  WebFrontend: 'https://chatclb.dev',
  WebAdminFrontend: "https://admin.chatclb.dev",
  WebSocket: 'wss://api.chatclb.dev',
};

export const oneSignalAppId = '5071c6e6-e9ae-4d50-93b4-7999c2496639';